import { ChangeDetectorRef,Component } from '@angular/core';
   
import { Product } from '../../interfaces/product.interface'; 
import { ProductcodeService } from "../../services/productcode";
import { Router } from '@angular/router';
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-add-product',
  imports: [ReactiveFormsModule],
  templateUrl: './add-product.html',
  styleUrl: './add-product.css',
})
export class AddProductComponent  {
  products: Product[] = [];
  myForm: FormGroup;

  constructor(private productcodeService: ProductcodeService, 
                private cdr: ChangeDetectorRef,
                private router: Router,
                private fb: FormBuilder) 
                {
                  this.myForm = this.fb.group({
                    description: new FormControl('',[Validators.required,Validators.maxLength(100)]),
                    description2: new FormControl('',[Validators.required,Validators.maxLength(100)]),
                    productcode: new FormControl('',[Validators.maxLength(25)]),
                    uom: new FormControl('',[Validators.maxLength(5)]) 
                  });
                }



                
get description() { return this.myForm.get('description'); }
get description2() { return this.myForm.get('description2'); }
get productcode() { return this.myForm.get('productcode'); }
get uom() { return this.myForm.get('uom'); }

async addProduct(): Promise<void>
  {
    var description = this.myForm.value.description != null ? this.myForm.value.description.trim() : "";
    var description2 = this.myForm.value.description2 != null ? this.myForm.value.description2.trim() : "";
    var productcode = this.myForm.value.productcode != null ? this.myForm.value.productcode.trim() : "";
    var uom = this.myForm.value.uom != null ? this.myForm.value.uom.trim() : "";

    if (this.myForm.invalid && this.myForm.touched)
    {
      return;
    }

 try
        {
          await this.productcodeService.create(description,description2,productcode,uom);
          this.cdr.detectChanges();
          this.router.navigateByUrl('product'); 
        } catch (error) {
          console.error('createproduct error',error);
        }

  }   

  goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('product');
  }                

}

